import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeletePopupRes;
export const DeletePopupTodo = createAsyncThunk('DeletePopup', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `popup_data/${id}`,
          
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeletePopupRes = res.data
        
    } catch (error) {
        return DeletePopupRes = error.response.data
    }
})
